import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { InputActionMeta } from "react-select";

interface LocationFieldProps {
  id: string;
  fieldName: string;
  value: string;
  onInputChange: (value: string) => void;
  onChange: (value: string) => void;
}

export function LocationField({ id, fieldName, value, onInputChange, onChange }: LocationFieldProps) {
  return (
    <GooglePlacesAutocomplete
      apiKey={import.meta.env.VITE_GOOGLE_PLACES_KEY}
      debounce={800}
      selectProps={{
        styles: {
          control: (provided) => ({
            ...provided,
            height: "55px",
          }),
        },
        id: id,
        placeholder: "Type in your location",
        value: null,
        inputValue: value || "",
        closeMenuOnSelect: false,
        blurInputOnSelect: true,
        noOptionsMessage: () => "Please type or change your location",
        onInputChange: (newValue: string, actionMeta: InputActionMeta) => {
          if (actionMeta?.action !== "input-blur" && actionMeta?.action !== "menu-close") {
            onInputChange(newValue);
          }
        },
        onChange: (place: any) => {
          onInputChange(place.label);
          onChange(place.label);
        },
      }}
    />
  );
}
